import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { MetodosModal } from '../../interfaces/metodos-modal.interface';
import { ModalRoleEnum } from '../../enums/modal-role.enum';
import { HelpersUtil } from '../../utils/helpers.util';
import { KeyboardKeysEnum } from '../../enums/keyboard-keys.enum';
import { DialogStateUtil } from '../../utils/dialog-state.util';

@Component({
  selector: 'app-selecionar-qtd-fatias',
  templateUrl: './selecionar-qtd-fatias.dialog.html',
  styleUrls: ['./selecionar-qtd-fatias.dialog.scss']
})
export class SelecionarQtdFatiasDialog implements OnInit, MetodosModal {
  // ModalProps
  qtdFatias: number[] = [];

  qtdSelecionada: number = -1;

  @ViewChild('select', { static: false }) private select: ElementRef<HTMLSelectElement>;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit(): void {
    HelpersUtil.executeAfterDelay(() => this.select.nativeElement.focus());
  }

  cancel(): void {
    this.modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);
    DialogStateUtil.dialogIsClosed();
  }

  confirm(): void {
    const dataClose = new SelecionarQtdFatiasDataClose(this.qtdSelecionada);

    this.modalCtrl.dismiss(dataClose, ModalRoleEnum.CONFIRM);
    DialogStateUtil.dialogIsClosed();
  }

  @HostListener('window:keydown', ['$event'])
  private async handleKeyboardEvent(event: KeyboardEvent) {
    switch (event.key) {
      case KeyboardKeysEnum.Escape:
        this.cancel();
        break;
      case KeyboardKeysEnum.F5:
        this.confirm();
        break;
    }
  }
}

export class SelecionarQtdFatiasDataClose {
  constructor(
    public qtdSelecionada: number
  ) { }
}